import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";

import {LorenGeofencingPolygon} from "../../interfaces/loren-geofencing-polygon.interface";
import {BaseEntitiesResolver} from "../../../../shared/resolvers/loren-base-entities-resolver/base-entities.resolver";
import {
    LorenGeofencingPolygonService
} from "../../services/loren-geofencing-polygon-service/loren-geofencing-polygon.service";

@Injectable()
export class LorenGeofencingAllPolygonsResolver extends BaseEntitiesResolver<LorenGeofencingPolygon> {
    protected service = inject(LorenGeofencingPolygonService);
    protected router = inject(Router);

    resolve() {
        return this.service.query().pipe(map((res) => res.items));
    }
}
